import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import Container from "../hoc/Container";
import backendApiService from "../service/backend-api.service";
import { useAccount } from "./AccountContext";
import AccountLogin from "./AccountLogin";
import AccountOrders from "./AccountOrders";
import { HeartIcon } from "@heroicons/react/24/outline";
import AccountFavorites, { FAVORITES_TITLE_ID } from "../favorites/AccountFavorites";
import { useFavorites } from "../favorites/FavoritesContext";

function AccountControls({ onSignedOut }) {
  const { logout } = useAccount();
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const run = async (action) => {
    setBusy(true);
    setError("");
    try {
      await action();
      onSignedOut();
    } catch (actionError) {
      setError(actionError.message);
      setBusy(false);
    }
  };

  return (
    <div className="account-controls">
      <div className="account-controls-row">
        <button type="button" className="account-secondary-btn" disabled={busy} onClick={() => run(logout)}>
          Выйти
        </button>
        <button
          type="button"
          className="account-secondary-btn"
          disabled={busy}
          onClick={() => run(() => backendApiService.logoutAll())}
        >
          Выйти на всех устройствах
        </button>
        {!confirmDelete ? (
          <button
            type="button"
            className="account-danger-link"
            disabled={busy}
            onClick={() => setConfirmDelete(true)}
          >
            Удалить кабинет
          </button>
        ) : null}
      </div>
      {confirmDelete ? (
        <div className="account-confirm" role="alertdialog" aria-label="Удаление кабинета">
          <p className="other-store-description">
            Удалить кабинет? Заказы и письма с кодами останутся, а войти снова
            можно в любой момент по той же почте.
          </p>
          <div className="account-controls-row">
            <button
              type="button"
              className="account-danger-btn"
              disabled={busy}
              onClick={() => run(() => backendApiService.deleteAccount())}
            >
              Удалить
            </button>
            <button
              type="button"
              className="account-secondary-btn"
              disabled={busy}
              onClick={() => setConfirmDelete(false)}
            >
              Отмена
            </button>
          </div>
        </div>
      ) : null}
      {error ? <p className="other-store-error">{error}</p> : null}
    </div>
  );
}

function FavoritesJump() {
  const { items, ready } = useFavorites();
  const jump = () => {
    const title = document.getElementById(FAVORITES_TITLE_ID);
    if (!title) return;
    title.scrollIntoView({ behavior: "smooth", block: "start" });
    title.focus({ preventScroll: true });
  };
  return (
    <div className="account-quick-nav">
      <button type="button" className="account-nav-btn" onClick={jump}>
        <HeartIcon className="h-4 w-4" aria-hidden="true" />
        Избранные игры
        {ready && items.length ? <span className="account-nav-count">{items.length}</span> : null}
      </button>
    </div>
  );
}

function AccountPage() {
  const { account, loading, setAccount } = useAccount();
  const signOut = useCallback(() => setAccount(null), [setAccount]);

  return (
    <Container>
      <section className="content-block mb-2">
        <nav className="other-store-breadcrumb">
          <Link to="/" className="other-store-breadcrumb-link">
            Главная
          </Link>
          <span aria-hidden="true">/</span>
          <span>Кабинет</span>
        </nav>
        <div className={`other-store-order-card account-card${account ? "" : " account-card-login"}`}>
          <h1 className="other-store-title account-title">
            {account ? "Личный кабинет" : "Вход в кабинет"}
          </h1>
          {loading ? <p className="other-store-description">Загрузка…</p> : null}
          {!loading && !account ? <AccountLogin onLoggedIn={setAccount} /> : null}
          {!loading && account ? (
            <>
              <p className="other-store-description account-email">
                Почта кабинета: <strong>{account.email}</strong>
              </p>
              <FavoritesJump />
              <AccountOrders email={account.email} onUnauthorized={signOut} />
              <AccountFavorites />
              <AccountControls onSignedOut={signOut} />
            </>
          ) : null}
        </div>
      </section>
    </Container>
  );
}

export default AccountPage;
